import { CommonUtil } from '@utils/common/common';
import { integerFormatter, percentFormatter } from '@utils/common/formatter';

export class KeywordResearch {
  resultOption(responseData, registeredKeywordList, groupList, groupHandler, addDelHandler, currentTabIndex) {
    console.log('responseData: ', responseData);
    const _data = CommonUtil.getArrayByValidate(responseData);

    const columns = [
      {
        name: 'Keyword',
        selector: (row) => row.keyword,
        cell: (row) => row.keyword,
        sortable: true,
      },
      {
        name: 'Search Score',
        selector: (row) => row.searchScore,
        cell: (row) => integerFormatter(row.searchScore),
        sortable: true,
      },
      {
        name: 'Group',
        selector: (row) => row.group,
        cell: (row, index, column, id) => (
          <label className="select">
            <select
              name="score"
              onChange={(e) => groupHandler(e, row.keyword)}
              // value={row.group === null ? 'nothing' : row.group}
              disabled={row.tracked ? true : false}
            >
              <option value={'nothing'} selected={row.group === null ? true : false}>
                {'Select Group'}
              </option>
              {groupList &&
                groupList?.length > 0 &&
                groupList.map((item, index) => (
                  <option key={item.id} value={item.value} selected={item.value === row.group ? true : false}>
                    {item.text}
                  </option>
                ))}
            </select>
          </label>
        ),
        sortable: true,
      },
      {
        name: 'Add/Del',
        selector: (row) => row.tracked,
        cell: (row, index, column, id) => (
          <>
            {row.tracked ? (
              <button
                type="button"
                className="btn-ico-single delete"
                title="delete"
                onClick={() => addDelHandler(currentTabIndex, row)}
              >
                <span className="blind">delete</span>
              </button>
            ) : (
              <>
                <input
                  type="checkbox"
                  className="ipt-check"
                  id={`checked-table-${row.keyword}`}
                  checked={false} // 퍼블리싱은 V 처리를 했지만.. 여기선 제외시킨다.
                  onChange={() => addDelHandler(currentTabIndex, row)}
                />
                <label htmlFor={`checked-table-${row.keyword}`}>
                  <span className="blind">미선택</span>
                </label>
              </>
            )}
          </>
        ),
        sortable: true,
      },
    ];

    return {
      data: _data,
      columns: columns,
    };
  }
  // 바뀐 함수
  registeredOption(responseData, keywordHandler, deleteHandler) {
    const _data = CommonUtil.getArrayByValidate(responseData);
    const columns = [
      {
        name: '',
        cell: (row) => <div>{row.brand && <span className="icon-brand">B</span>}</div>,
        sortable: false,
        width: '25px',
      },
      {
        name: 'Keyword',
        selector: (row) => row.keyword,
        cell: (row, index, column, id) => {
          return (
            <div>
              {/* {row.brand && <span className="icon-brand">B</span>} */}
              <button onClick={() => keywordHandler(row.id, row.keyword)}>
                <span className="tb-icon-text">{row.keyword}</span>
              </button>
              <button type="button" className="btn-tiny thr" onClick={() => deleteHandler(row.id, row.keyword)}>
                D
              </button>
            </div>
          );
        },
        sortable: true,
        minWidth: '200px',
      },
      {
        name: (
          <>
            Search
            <br />
            score
          </>
        ),
        selector: (row) => row.searchScore,
        cell: (row) => integerFormatter(row.searchScore),
        sortable: true,
        maxWidth: '70px',
      },
      {
        name: 'Apps',
        selector: (row) => row.apps,
        cell: (row) => integerFormatter(row.apps),
        sortable: true,
        maxWidth: '70px',
      },
      {
        name: 'Chance',
        selector: (row) => row.chance,
        cell: (row) => percentFormatter(row.chance * 100),
        sortable: true,
        maxWidth: '70px',
      },
    ];

    return {
      data: _data,
      columns,
    };
  }
}
